import { useEffect, useMemo, useState } from "react";
import Aside from "../../../components/Aside";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { ReportService } from "../../../services/ReportsService";
import CustomDataTable from "../../../components/CustomDataTable";
import Tooltip from "../../../components/Tooltip";
import { AlertService } from "../../../services/Alert";
import { DateUtil } from "../../../utils/date";
import { NumberUtil } from "../../../utils/number";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
import LoaderSmall from "../../../components/LoaderSmall";
function PaymentsReportPage() {

    const { t }=useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();

    const [filterRangeDates, setFilterRangeDates] = useState({ start: null, end: null })
    
    const [rows, setRows] = useState([])


    const columns = [
        {
            name:t("reports.payments.ticket-id"),
            sortable: true,
            cell: row => {

                let ticket = row.ticket.split('-')[0]

                return (
                    <Tooltip title={row.ticket} className="d-grid gap-2">
                        <p className="text-nowrap  link-underline cursor-pointer mb-0" onClick={() => copyToClipboard(row.ticket)}>{ticket}</p>
                    </Tooltip>
                )
            },
        },
        {
            name: t("reports.payments.payment"),
            sortable: true,
            selector: row => row.method ,
        },
        {
            name: t("reports.payments.amount"),
            sortable: true,
            selector: row => <p className="text-nowrap mb-0">${NumberUtil.format(+row.amount)}</p> ,
        },
        {
            name: t("reports.payments.id-payment"),
            sortable: true,
            cell: row => <p className="text-nowrap mb-0">{row.external_order_id || <span className="badge bg-soft-danger text-danger">Sin información</span> } </p>,
        },
        {
            name: t("reports.payments.status"),
            sortable: true,
            cell: row => {
                switch (row.status) {
                    case 'PENDING':
                        
                        return <span className="badge bg-warning ">Pendiente</span>
                    case 'CANCELED':
                        
                        return <span className="badge bg-soft-danger text-danger">Cancelado</span>
                    case 'APPROVED':
                        
                        return <span className="badge bg-soft-primary text-primary">Aprobado</span>
                    case 'FAILED':
                        
                        return <span className="badge bg-soft-danger text-danger">Fallido</span>
                    default:
                        return <span className="badge bg-soft-danger text-danger">Sin información</span>
                }
            },
        },
        {
            name: t("reports.payments.customer"),
            sortable: true,
            cell: row => <p className="text-nowrap mb-0">{row.client_name || <span className="badge bg-soft-danger text-danger">Sin información</span> }</p>,
        },
        {
            name: t("reports.payments.agent"),
            sortable: true,
            cell: row => <p className="text-nowrap mb-0">{row.agent_name || <span className="badge bg-soft-danger text-danger">Sin información</span> }</p>,
        },
        {
            name: t("reports.payments.creation-date"),
            sortable: true,
            cell: row => <p className="text-nowrap mb-0">{DateUtil.format(row.created_date) }</p>,
        },
        

    ];

    const total = useMemo(() => rows.length, [rows])
    const totalAmount = useMemo(() => rows.map( row => +row.amount).reduce( (a,b) => a+b, 0), [rows])

    const totalApproved = useMemo(() => rows.filter( row => row.status === 'APPROVED').length, [rows])
    const totalApprovedAmount = useMemo(() => rows.filter( row => row.status === 'APPROVED').map( row => +row.amount).reduce( (a,b) => a+b, 0), [rows])

    const totalPending = useMemo(() => rows.filter( row => row.status === 'PENDING').length, [rows])
    const totalPendingAmount = useMemo(() => rows.filter( row => row.status === 'PENDING').map( row => +row.amount).reduce( (a,b) => a+b, 0), [rows])

    const totalFailed = useMemo(() => rows.filter( row => row.status === 'CANCELED' || row.status === 'FAILED' ).length, [rows])
    const totalFailedAmount = useMemo(() => rows.filter( row => row.status === 'CANCELED' || row.status === 'FAILED').map( row => +row.amount).reduce( (a,b) => a+b, 0), [rows])

    const copyToClipboard = async (text) => {
        await navigator.clipboard.writeText(text);

        AlertService.toastSuccess('Texto copiado', 2000)
    }
    
    const getReport = async() => {
        if (filterRangeDates.start && filterRangeDates.end) {
            const start = filterRangeDates.start.format('YYYY-MM-DD')
            const end = filterRangeDates.end.format('YYYY-MM-DD')

            const { data } = await call(()=> ReportService.getReportPayments(account.id, start, end));
            setRows(data)
        }
    }

    useEffect(() => {
      getReport()
    }, [filterRangeDates])
    

    const heightRequesting = useMemo(()=> {return isRequesting ? 'mt-50 mb-50':''},[isRequesting]);
    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item " aria-current="page">{t("reports.reports-title")}</li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("reports.payments.payment-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-grid-1x2 nav-icon"></i> {t("reports.reports-title")} - {t("reports.payments.payment-title")} </h1>
                            </div>

                        </div>
                    </div>

                    <div className=" mb-3 mb-lg-5">
                        

                        <div className={`row gx-lg-6 relative ${heightRequesting}`}>
                            {
                                isRequesting ? <LoaderSmall/> :
                            <>
                            <div className="col-lg-3 mb-md-3 mb-3">
                                <div className="card card-sm " >
                                    <div className="card-body">
                                        <div className="d-flex ">
                                            <div className="flex-grow-1 ">
                                                <h6 className="card-subtitle mb-3">{t("reports.payments.promises")}</h6>
                                                <div className="">
                                                    <h1 className="card-title">$ {NumberUtil.format(totalAmount)}</h1>
                                                    <span className="text-body fs-5 ms-1">{NumberUtil.format(total)} {t("reports.payments.orders-text")}</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 mb-md-3 mb-3">
                                <div className="card card-sm " >
                                    <div className="card-body">
                                        <div className="d-flex ">
                                            <div className="flex-grow-1 ">
                                                <h6 className="card-subtitle mb-3">{t("reports.payments.approved")}</h6>
                                                <div className="">
                                                    <h1 className="card-title">$ {NumberUtil.format(totalApprovedAmount)}</h1>
                                                    <span className="text-body fs-5 ms-1">{NumberUtil.format(totalApproved)} {t("reports.payments.orders-approved")}</span>
                                                </div>

                                              
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 mb-md-3 mb-3">
                                <div className="card card-sm ">
                                    <div className="card-body">
                                        <div className="d-flex">
                                            <div className="flex-grow-1">
                                                <h6 className="card-subtitle mb-3">{t("reports.payments.in-process")}</h6>
                                                <div className="">
                                                    <h1 className="card-title">$ {NumberUtil.format(totalPendingAmount)}</h1>
                                                    <span className="text-body fs-5 ms-1">{NumberUtil.format(totalPending)} {t("reports.payments.orders-process")}</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="card card-sm ">
                                    <div className="card-body">
                                        <div className="d-flex">
                                            <div className="flex-grow-1">
                                                <h6 className="card-subtitle mb-3">{t("reports.payments.failed")}</h6>
                                                <div className="">
                                                    <h1 className="card-title">$ {NumberUtil.format(totalFailedAmount)}</h1>
                                                    <span className="text-body fs-5 ms-1">{NumberUtil.format(totalFailed)} {t("reports.payments.orders-failure")}</span>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            </>
                            }
                        </div>

                    </div>


                    <CustomDataTable
                        columns={columns}
                        showDates
                        data={rows}
                        hideAccountsFilter
                        showExport={false}
                        isLoading={isRequesting}
                        onDatesChange={(range) => setFilterRangeDates(range)}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.ticket}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.method}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.amount}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.external_order_id}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.status}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.client_name}`.match(new RegExp(`${term}`, 'i')) || 
                                `${row.agent_name}`.match(new RegExp(`${term}`, 'i'))
                                
                            )
                        }}
                    />

                </div>
                <Footer />
            </main>


        </>
    )
}
export default PaymentsReportPage